<template>
    <div :class="{ 'footer-mobile': true, disabled: show_active_nav }" id="mobile-menu" v-if="!is_landing">
        <ul class="main-nav-links">
            <li :class="{ active: is_event_menu }">
                <a @click="$router.push({ path: '/events' })" href="javascript:{}">
                    <!--<span class="count">12</span>-->
                    <span class="icon-events"></span>
                    Events</a
                >
            </li>
            <li :class="{ active: is_tasks_menu }">
                <a @click="$router.push({ path: '/tasks' })" href="javascript:{}">
                    <span class="icon-tasks"></span>
                    Tasks</a
                >
            </li>
            <li :class="{ active: $route.name === 'people' }">
                <a href="javascript:{}" @click="$router.push({ path: '/people' })">
                    <span class="icon-people"></span>
                    People</a
                >
            </li>
            <!--
            <li>
                <a href="">
                    <span class="icon-foods"></span>
                    Foods</a
                >
            </li>
            <li>
                <a href="">
                    <span class="icon-expenses"></span>
                    Expenses</a
                >
            </li>
            -->
        </ul>
    </div>
</template>

<script>
export default {
    name: "mobile-footer-menu",
    computed: {
        is_event_menu() {
            return this.$route.name === "events";
        },
        is_tasks_menu() {
            return this.$route.name === "tasks";
        },
        is_landing() {
            return this.$route.name === "landing";
        },
        show_active_nav() {
            return ["signup", "login", "forgot-password"].includes(this.$route.name);
        }
    }
};
</script>

<style scoped></style>
